export default "__VITE_ASSET__DoRXRuUE__"